import React, {Component} from "react";
import Style from "./FJPreviewRatio.module.less";

class FJPreviewRatio extends Component {
  render() {
    const {width, height, isShow, hasTransition} = this.props;
    return (
      <div className={Style.ratio_preview_box}
           style={{
             height: height + 'px',
             width: width + 'px',
             opacity: isShow ? 1 : 0,
             transitionDuration: hasTransition ? '0.15s' : '0s',
           }} />
    )
  }
}

export default FJPreviewRatio;
